import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted, onBeforeUnmount, ref, provide } from "vue";
import store from "@/store";
import Home from "./views/layout/home.vue";
import Api from "@/api/library/appletManage/SystemConfig";
import { Cookie, Key } from "@/utils/storage/cookie";

// 1. 定义响应式配置对象

// export default {
//   created() {
//     window.onresize = function () {
//       console.log("宽度", document.documentElement.clientWidth);
//       console.log("高度", document.documentElement.clientHeight);
//     };
//   },

// }
// 

export default {
  __name: 'App',
  setup(__props) {
    const globalConfig = ref({});

    // 2. 定义获取配置的方法
    const initGlobalConfig = async () => {
      try {
        // 1. Token 校验
        if (!Cookie.get(Key.token)) {
          return;
        }
        const userInfoStr = Cookie.get(Key.userinfo);
        // 再做个防御性判断：万一有 Token 但 Cookie 过期了也没存上 Userinfo
        if (!userInfoStr) {
          return;
        }
        const user = JSON.parse(userInfoStr);
        // --- 第三步：业务逻辑 ---
        const libid = user.libid;
        if (!libid) return;
        const res = await Api.listByLibId(libid);
        if (res.code == "200") {
          // 2. 核心修改：直接获取对象，不再需要判断数组或查找 isDefault
          const config = res.data;

          // 3. 只要后端返回了数据（无论是查到的还是 CENTER 兜底的），直接使用
          if (config) {
            globalConfig.value = config;

            // --- 设置 Title 和 Favicon ---
            if (globalConfig.value.systemName) {
              document.title = globalConfig.value.systemName;
            }
            // 注意：这里用的是你代码里的 logoIcon 字段
            if (globalConfig.value.logoIcon) {
              const faviconUrl = globalConfig.value.logoIcon;
              let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
              link.type = 'image/x-icon';
              link.rel = 'shortcut icon';
              link.href = faviconUrl;
              document.head.appendChild(link);
            }
          }
        }
      } catch (error) {
        console.error("全局配置初始化失败", error);
      }
    };

    // ----------------------------
    // 💡 自动初始化字体大小函数
    // ----------------------------
    function initFontSize() {
      // 从本地缓存读取上次用户选择的字体大小（默认为“中”）
      const savedSize = localStorage.getItem("app-font-size") || "中";

      // 调用 vuex 的 SET_FONT_SIZE mutation
      // mutation 内部会根据 window.devicePixelRatio 自动计算字体比例
      store.commit("SET_FONT_SIZE", savedSize);
    }
    // ----------------------------
    // 💡 监听系统缩放变化
    // ----------------------------
    function handleResize() {
      // 当窗口大小变化时重新设置字体（系统缩放或分辨率变化时都会触发）
      store.commit("SET_FONT_SIZE", store.state.fontSize);
    }

    // ----------------------------
    // 🚀 生命周期：组件挂载时执行
    // ----------------------------
    onMounted(() => {
      // 第一次进入页面时自动初始化字体
      initFontSize();

      // 监听浏览器窗口变化（包括系统缩放）
      window.addEventListener("resize", handleResize);
      console.log("[Font Adapt] 已初始化字体适配逻辑");
      initGlobalConfig();
    });
    provide('globalConfig', globalConfig);

    // ----------------------------
    // 🧹 生命周期：组件卸载时清理事件监听
    // ----------------------------
    onBeforeUnmount(() => {
      window.removeEventListener("resize", handleResize);
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view);
    };
  }
};